/* A lazy instantiation pattern  with a very simple api

    var x = lazy(function() {
        return 1;
    });

    console.log(x.isCreated) // false
    var y = x();             // 1
    console.log(x.isCreated) // true
    x.clear();
    console.log(x.isCreated) // false


    Other patterns:

    var x = lazy(function(arg1, arg2) {
        return arg1 + arg2;
    }, 'foo');

    var y = x('bar'); // foobar
*/
/*jshint onevar: false */
var slice = Array.prototype.slice;
/*jshint validthis: true */
function getValue(context, args) {
    if (!this.value.isCreated) {
        this._value = this.cotr.apply(context, (this.args || []).concat(args));
        this.value.isCreated = true;
    }
    return this._value;
}
var Lazy = function (cotr) {
    var that = this;
    this.cotr = cotr;
    this._value = void (0);
    this.value = function () {
        return getValue.call(that, this, slice.call(arguments));
    };
    this.value.clear = function () {
        that.value.isCreated = false;
    };
    this.value.clear();
};
export default function lazy(func) {
    var lazy = new Lazy(func);
    lazy.args = slice.call(arguments, 1);
    return lazy.value;
}
;
//# sourceMappingURL=lazy.js.map